"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LootboxBlockNumberTrackerToJSON = exports.LootboxBlockNumberTrackerFromJSONTyped = exports.LootboxBlockNumberTrackerFromJSON = void 0;
function LootboxBlockNumberTrackerFromJSON(json) {
    return LootboxBlockNumberTrackerFromJSONTyped(json, false);
}
exports.LootboxBlockNumberTrackerFromJSON = LootboxBlockNumberTrackerFromJSON;
function LootboxBlockNumberTrackerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'toBlockNumber': json['toBlockNumber'],
        'fromBlockNumber': json['fromBlockNumber'],
    };
}
exports.LootboxBlockNumberTrackerFromJSONTyped = LootboxBlockNumberTrackerFromJSONTyped;
function LootboxBlockNumberTrackerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'toBlockNumber': value.toBlockNumber,
        'fromBlockNumber': value.fromBlockNumber,
    };
}
exports.LootboxBlockNumberTrackerToJSON = LootboxBlockNumberTrackerToJSON;
